import { getPageSource, track } from '@mc/track-event'

export const trackContactUsClick = () => {
  track('Contact Sales Clicked', {
    page_source: getPageSource(),
  })
}
